import { render, staticRenderFns } from "./KeyFeedbackCard.vue?vue&type=template&id=06036697&scoped=true"
import script from "./KeyFeedbackCard.vue?vue&type=script&lang=js"
export * from "./KeyFeedbackCard.vue?vue&type=script&lang=js"
import style0 from "./KeyFeedbackCard.vue?vue&type=style&index=0&id=06036697&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06036697",
  null
  
)

export default component.exports